"use strict";
/* globals module */
/**
 * @module maintenanceClient
 * @description  Maintenance Client provides an easy way to consume  Password Recovery REST API end-points. In order to obtain needed routes `maintenanceClient` uses `maintenanceRoute`.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var httpApi_1 = require("../../../httpApi");
var _1 = require("./");
var MaintenanceClient = /** @class */ (function () {
    function MaintenanceClient(maintenanceRoute, apiClient) {
        this.maintenanceRoute = maintenanceRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(MaintenanceClient.prototype, "routeDefinition", {
        /**
         * Provides direct access to `maintenanceRoute`.
         * @method
         * @example maintenanceClient.routeDefinition.maintain(id);
         **/
        get: function () {
            return this.maintenanceRoute;
        },
        enumerable: true,
        configurable: true
    });
    MaintenanceClient.prototype.maintainApp = function (id) {
        return this.apiClient.put(this.routeDefinition.maintainApp(id), {});
    };
    MaintenanceClient.prototype.maintain = function () {
        return this.apiClient.put(this.routeDefinition.maintain(), {});
    };
    var _a, _b;
    MaintenanceClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.MaintenanceRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.MaintenanceRoute !== "undefined" && _1.MaintenanceRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], MaintenanceClient);
    return MaintenanceClient;
}());
exports.MaintenanceClient = MaintenanceClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
*/ 
